export default {
  RecommendKBNN : 'Đề nghị KBNN',
  TakeAccount : 'Trích tài khoản',
  ReduceReceiptTransfer : 'Giảm thu chuyển giao',
  NotSelect : 'Không chọn',
  TakeAccountNumber : 'Trích tài khoản số',
  DecisionNumber : 'Theo Quyết định số',
  Day : 'Ngày',
  Cancel : 'Hủy',
  ViewReport : 'Xem báo cáo',
  InfoGeneralTab : 'Thông tin chung',
  DeviceTab : 'Chia ra',


};
